import Vue from 'vue'

const components = {
  currency: () => import('./Currency.vue')
}

Object.entries(components).forEach(([name, component]) =>
  Vue.component(name, component)
)

export default {}
